import { jsx as r, jsxs as e } from "react/jsx-runtime";
const n = ({ size: o, className: t }) => /* @__PURE__ */ r(
  "svg",
  {
    className: t,
    fill: "none",
    height: o,
    viewBox: "0 0 24 24",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ r(
      "g",
      {
        clipPath: "url(#clip0_5445_4006)",
        id: "Wrap",
        children: /* @__PURE__ */ e("g", { id: "Group 2608606", children: [
          /* @__PURE__ */ r(
            "path",
            {
              d: "M4 4.99976L20 4.99976",
              id: "Line 1",
              stroke: "currentColor",
              strokeLinecap: "round",
              strokeWidth: "1.3"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              d: "M4 11.9998L20 11.9998",
              id: "Line 2",
              stroke: "currentColor",
              strokeLinecap: "round",
              strokeWidth: "1.3"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              d: "M4 18.9998L20 18.9998",
              id: "Line 3",
              stroke: "currentColor",
              strokeLinecap: "round",
              strokeWidth: "1.3"
            }
          )
        ] })
      }
    )
  }
);
export {
  n as Bars
};
